<template>
	<section class="app-main">
		<keep-alive :include="cache">
			<router-view></router-view>
		</keep-alive>
	</section>
</template>

<script>
	export default {
		name: 'Main',
		data(){
			return {
				cache:[]
				
			}
		},
		computed: {
			key() {
				return this.$route.fullPath
			}
		}
	}
</script>

<style scoped>

</style>
